var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUpRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#FFF2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 9.875C23.1523 9.875 23.625 10.3477 23.625 10.9062V21.2188C23.625 21.8203 23.1523 22.25 22.5938 22.25C21.9922 22.25 21.5625 21.8203 21.5625 21.2188V13.3984L11.6367 23.3242C11.207 23.7539 10.5625 23.7539 10.1758 23.3242C9.74609 22.9375 9.74609 22.293 10.1758 21.9062L20.1016 11.9805H12.2812C11.6797 11.9805 11.25 11.5078 11.25 10.9492C11.25 10.3477 11.6797 9.91797 12.2812 9.91797H22.5938V9.875Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUpRed);
export default __webpack_public_path__ + "static/media/trend-up-red.df66724a116f00e64ff57ca5f53a8049.svg";
export { ForwardRef as ReactComponent };